module.exports = __webpack_public_path__ + "fbcf6269.png";